import React, { ReactNode } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import ApiErrorModal from "../../components/Modals/ApiErrorModal/ApiErrorModal";
import CongratsModal from "../../components/Modals/CongratsModal/CongratsModal";
import DecisionModal from "../../components/Modals/DecisionModal/DecisionModal";
import FailModal from "../../components/Modals/FailModal/FailModal";
import GiveUpModal from "../../components/Modals/GiveUpModal/GiveUpModal";
import NewGameModal from "../../components/Modals/NewGameModal/NewGameModal";
import PaymentSuccessModal from "../../components/Modals/PaymentSuccessModal/PaymentSuccessModal";
import { apiErrorReset } from "../../core/app/apiError/actions";
import { setMe } from "../../core/app/setMe/actions";
import { setModalVisibility } from "../../core/app/setModalVisibility/actions";
import { setSelectedOffer } from "../../core/app/setSelectedOffer/actions";
import { ModalType } from "../../core/models/custom/enums/modalType";
import { ModalVisibilityPayload } from "../../core/models/custom/modalVisibility.payload";
import { MeDto } from "../../core/models/dtos/me.dto";
import { OfferDto } from "../../core/models/dtos/offer.dto";
import { UserQuestionDto } from "../../core/models/dtos/userQuestion.dto";
import { UserState } from "../../core/models/enums/userState";
import { AnswerRequest } from "../../core/models/requests/answer.request";
import { OfferRequest } from "../../core/models/requests/offer.request";
import FirebaseService from "../../core/services/firebase.service";
import { answerQuestion } from "../../core/services/userService/answerQuestion/actions";
import { AnswerQuestionState } from "../../core/services/userService/answerQuestion/types";
import { applyOffer } from "../../core/services/userService/applyOffer/actions";
import { ApplyOfferState } from "../../core/services/userService/applyOffer/types";
import { getMe } from "../../core/services/userService/getMe/actions";
import { GetMeState } from "../../core/services/userService/getMe/types";
import { paymentFail } from "../../core/services/userService/paymentFail/actions";
import { paymentRequest } from "../../core/services/userService/paymentRequest/actions";
import { Constants } from "../../core/utilities/constants";
import { Helpers } from "../../core/utilities/helpers";
import { withRouter, WithRouterProps } from "../../core/utilities/hooks";
import { IStore } from "../../core/utilities/reducers";
import { router } from "../../core/utilities/router";
import { LocalStorage } from "../../core/utilities/storage";
import Question, { QuestionModel } from "./Question/Question";
import "./QuestionPage.scss";

declare global {
  interface Window {
    noAction: any;
    tokenBalanceCheckCompleted: any;
  }
}

interface IProps {
  me?: MeDto;
  modalVisibilityData: ModalType[];
  selectedOffer?: OfferDto;
  getMeState: GetMeState;
  answerQuestionState: AnswerQuestionState;
  applyOfferState: ApplyOfferState;
  setMe: (me?: MeDto) => void;
  getMe: () => void;
  answerQuestion: (request: AnswerRequest) => void;
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
  setSelectedOffer: (offer: OfferDto) => void;
  applyOffer: (request: OfferRequest) => void;
  paymentRequest: () => void;
  paymentFail: () => void;
  apiErrorReset: () => void;
}

interface IState {
  questionModel?: QuestionModel;
  intervalId?: NodeJS.Timeout;
  secondsLeft: number;
  selectedOptionId?: number;
  correctOptionId?: number;
  closeModalAfterSuccessPayment?: ModalType;
  isPlayButtonDisabled: boolean;
}

class QuestionPage extends React.Component<WithRouterProps<IProps>> {
  state: IState = {
    questionModel: undefined,
    intervalId: undefined,
    secondsLeft: Constants.questionDurationInSeconds,
    selectedOptionId: undefined,
    correctOptionId: undefined,
    closeModalAfterSuccessPayment: undefined,
    isPlayButtonDisabled: false,
  };

  constructor(props: WithRouterProps<IProps>) {
    super(props);
    this.bindInAppPurchaseSuccess();
    this.bindNoAction();
  }

  componentDidMount() {
    this.checkMe();
  }

  async componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<{}>,
    snapshot?: any
  ): Promise<void> {
    if (
      prevProps.answerQuestionState.loading &&
      !this.props.answerQuestionState.loading
    ) {
      const me = this.props.answerQuestionState.data;
      if (me) {
        if (me.state === UserState.COMPETING) {
          if (me.userQuestion) {
            await this.handleCorrectAnswer(
              me.userQuestion.expireAt,
              me.previousCorrectId
            );
            this.checkMe();
          } else {
            alert("userQuestion not defined at competing stage!");
            this.props.navigate(router.HOME);
            return;
          }
        } else {
          await this.handleCorrectAnswerClientSide(me.previousCorrectId);
          this.checkMe();
        }
      }
    }

    if (prevProps.getMeState.loading && !this.props.getMeState.loading) {
      if (this.props.getMeState.data) {
        this.checkMe();
      }
    }

    if (
      prevProps.applyOfferState.loading &&
      !this.props.applyOfferState.loading
    ) {
      if (this.props.applyOfferState.data) {
        this.checkMe();
      }
    }
  }

  private checkMe(): void {
    const me = this.props.me;
    if (me) {
      switch (me.state) {
        case UserState.COMPETING:
          this.setQuestion(me);
          break;
        case UserState.JUST_CREATED:
          this.props.setModalVisibility({
            modal: ModalType.NEW_GAME,
            isVisible: true,
          });
          break;
        case UserState.QUESTION_FAILED:
          this.props.setModalVisibility({
            modal: ModalType.FAIL,
            isVisible: true,
          });
          break;
        case UserState.DECISION_TIME:
          this.props.setModalVisibility({
            modal: ModalType.DECISION,
            isVisible: true,
          });
          break;
        case UserState.GIVE_UP:
          if (LocalStorage.isValueTrue(LocalStorage.modalGiveUp)) {
            this.props.setModalVisibility({
              modal: ModalType.GIVE_UP,
              isVisible: true,
            });
          } else {
            this.props.setModalVisibility({
              modal: ModalType.NEW_GAME,
              isVisible: true,
            });
          }
          break;
        case UserState.WINNER:
          if (LocalStorage.isValueTrue(LocalStorage.modalCongrats)) {
            this.props.setModalVisibility({
              modal: ModalType.CONGRATS,
              isVisible: true,
            });
          } else {
            this.props.setModalVisibility({
              modal: ModalType.NEW_GAME,
              isVisible: true,
            });
          }
          break;
        default:
          alert(`Undefined user state: ${me.state}`);
          this.props.navigate(router.HOME);
          return;
      }
    } else {
      alert(`Me not defined!`);
      this.props.navigate(router.HOME);
      return;
    }
  }

  private tick(): void {
    const newCount = Helpers.getDiffSeconds(
      this.state.questionModel?.userQuestion?.expireAt ?? new Date()
    );
    const secondsLeft = newCount <= 0 ? 0 : newCount;
    this.setState({ secondsLeft });
    if (secondsLeft <= 0) {
      this.handleQuestionTimeIsUp();
      this.clearInterval();
    }
  }

  private startTimer(): void {
    const intervalId = setInterval(() => this.tick(), 1000);
    this.setState({ intervalId });
  }

  private setQuestionModel(level: number, userQuestion: UserQuestionDto): void {
    const questionModel: QuestionModel = {
      level,
      userQuestion,
      callbackOptionClick: (optionId) => this.handleOptionClick(optionId),
    };
    this.setState({
      questionModel,
      secondsLeft: Constants.questionDurationInSeconds,
      selectedOptionId: undefined,
      correctOptionId: undefined,
    });
  }

  private setQuestion(me: MeDto): void {
    if (me.userQuestion) {
      const countdownSeconds = Helpers.getQuestionCountdownSeconds(
        me.userQuestion.expireAt
      );
      if (countdownSeconds >= 2) {
        this.props.setModalVisibility({
          modal: ModalType.PAYMENT_SUCCESS,
          isVisible: true,
        });
      } else {
        this.startTimer();
        this.setQuestionModel(me.level, me.userQuestion);
      }
    } else {
      alert("userQuestion not defined at competing stage!");
      this.props.navigate(router.HOME);
    }
  }

  private handleOpenInAppPurchases(offer: OfferDto): void {
    this.props.paymentRequest();
    try {
      (window as any).webkit.messageHandlers.checkTokenBalance.postMessage(
        JSON.stringify({ tokenAmount: offer.tokenAmount })
      );
    } catch (e) {
      console.log(e);
    }
    try {
      (window as any).JSBridge.checkTokenBalance(
        JSON.stringify({ tokenAmount: offer.tokenAmount })
      );
    } catch (e) {
      console.log(e);
    }
  }

  private bindNoAction(): void {
    window.noAction = () => {
      this.setState({ isPlayButtonDisabled: false });
    };
  }

  private bindInAppPurchaseSuccess(): void {
    window.tokenBalanceCheckCompleted = async () => {
      this.setState({ isPlayButtonDisabled: false });

      if (this.state.closeModalAfterSuccessPayment) {
        this.props.setModalVisibility({
          modal: this.state.closeModalAfterSuccessPayment,
          isVisible: false,
        });
      }
      const selectedOffer = this.props.selectedOffer;
      if (selectedOffer) {
        FirebaseService.logEvent(
          FirebaseService.user_count_kmb_payment_request_success
        );
        this.props.applyOffer({
          offerType: selectedOffer.type,
        });
      } else {
        alert("Selected offer not defined after payment!");
      }
    };
  }

  private handleOptionClick(optionId: number): void {
    if (this.props.applyOfferState.loading) {
      return;
    }
    this.setState({ selectedOptionId: optionId });
    this.clearInterval();
    this.props.answerQuestion({ answerId: optionId });
  }

  private handleQuestionTimeIsUp(): void {
    this.props.getMe();
  }

  private async handleCorrectAnswer(
    newQuestionExpireAt: Date,
    correctOptionId?: number
  ): Promise<void> {
    const newQuestionMillisecondsLeft =
      Helpers.getDiffMilliseconds(newQuestionExpireAt);
    const extraTime =
      newQuestionMillisecondsLeft - Constants.questionDurationInSeconds * 1000;
    const safeExtraTime = extraTime - 1000;
    if (safeExtraTime <= 0) {
      return;
    }
    await Helpers.wait(safeExtraTime / 2);
    this.setState({ correctOptionId });
    await Helpers.wait(safeExtraTime / 2);
  }

  private async handleCorrectAnswerClientSide(
    correctOptionId?: number
  ): Promise<void> {
    await Helpers.wait(Constants.showCorrectAnswerDurationInMilliseconds);
    this.setState({ correctOptionId });
    await Helpers.wait(Constants.showCorrectAnswerDurationInMilliseconds);
  }

  private handleModalOffer(modal: ModalType, offer: OfferDto): void {
    if (this.state.isPlayButtonDisabled) {
      return;
    }
    this.props.setSelectedOffer(offer);
    if (!offer.appleProductId || !offer.googleProductId) {
      this.props.setModalVisibility({ modal: modal, isVisible: false });
      this.props.applyOffer({ offerType: offer.type });
    } else {
      this.setState({
        closeModalAfterSuccessPayment: modal,
        isPlayButtonDisabled: true,
      });
      this.handleOpenInAppPurchases(offer);
    }
  }

  private handleErrorButtonRetry(): void {
    this.props.apiErrorReset();
    this.checkMe();
  }

  private handleErrorButtonHome(): void {
    this.props.apiErrorReset();
    // To avoid error modal blink on HomePage
    Helpers.wait(200).then(() => {
      this.props.navigate(router.HOME);
    });
  }

  private renderQuestion(): ReactNode {
    if (this.state.questionModel) {
      return (
        <Question
          questionModel={this.state.questionModel}
          secondsLeft={this.state.secondsLeft}
          selectedOptionId={this.state.selectedOptionId}
          correctOptionId={this.state.correctOptionId}
        />
      );
    }
    return <React.Fragment />;
  }

  private clearInterval(): void {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }

  render() {
    return (
      <div id="question-page" className="page">
        <div className="page-content">{this.renderQuestion()}</div>
        {this.props.modalVisibilityData.includes(ModalType.NEW_GAME) && (
          <NewGameModal
            callback={(modal, offer) => this.handleModalOffer(modal, offer)}
          />
        )}
        {this.props.modalVisibilityData.includes(ModalType.FAIL) && (
          <FailModal
            callback={(modal, offer) => this.handleModalOffer(modal, offer)}
          />
        )}
        {this.props.modalVisibilityData.includes(ModalType.DECISION) && (
          <DecisionModal
            callback={(modal, offer) => this.handleModalOffer(modal, offer)}
          />
        )}
        {this.props.modalVisibilityData.includes(ModalType.GIVE_UP) && (
          <GiveUpModal
            callback={(modal, offer) => this.handleModalOffer(modal, offer)}
          />
        )}
        {this.props.modalVisibilityData.includes(ModalType.CONGRATS) && (
          <CongratsModal
            callback={(modal, offer) => this.handleModalOffer(modal, offer)}
          />
        )}
        {this.props.modalVisibilityData.includes(ModalType.PAYMENT_SUCCESS) && (
          <PaymentSuccessModal
            secondsLeftInitial={Helpers.getQuestionCountdownSeconds(
              this.props.me?.userQuestion?.expireAt
            )}
            callback={(me) => this.setQuestion(me)}
          />
        )}
        <ApiErrorModal
          callbackForQuestionPageRetry={() => this.handleErrorButtonRetry()}
          callbackForQuestionPageHome={() => this.handleErrorButtonHome()}
        />
      </div>
    );
  }

  componentWillUnmount() {
    this.clearInterval();
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setMe,
      getMe,
      setModalVisibility,
      setSelectedOffer,
      answerQuestion,
      applyOffer,
      paymentRequest,
      paymentFail,
      apiErrorReset,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
    modalVisibilityData: store.setModalVisibility.data,
    selectedOffer: store.setSelectedOffer.offer,
    getMeState: store.getMe,
    answerQuestionState: store.answerQuestion,
    applyOfferState: store.applyOffer,
    paymentFailState: store.paymentFail,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<IProps>(QuestionPage));
